import { createContext } from 'react';

export interface IBreadcrumbPathSegment {
	title: string;
	to: string;
}

export interface IBreadcrumbContextContent {
	breadcrumbs: IBreadcrumbPathSegment[];
	registerBreadcrumb: (breadcrumb: IBreadcrumbPathSegment) => void;
	unregisterBreadcrumb: (url: string) => void;
	updateBreadcrumb: (url: string, breadcrumb: IBreadcrumbPathSegment) => void;
}

export const BreadcrumbContext = createContext<IBreadcrumbContextContent>({
	breadcrumbs: [],
	registerBreadcrumb: () => {},
	unregisterBreadcrumb: () => {},
	updateBreadcrumb: () => {},
});
